/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * AtpSlotsInformationState Input Action
 */
export class AtpSlotsInformationStateInput implements Msdyn365.IActionInput {
    // AtpSlotsInformationState: Construct the input needed to run the action
    constructor() {}

    // AtpSlotsInformationState: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `AtpSlotsInformationState`;
    public getCacheObjectType = () => 'AtpSlotsInformationState';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// AtpSlotsInformationState: Create a data model here or import one to capture the response of the action
export interface IAtpSlotsInformationStateData {
    checkAvailable?: boolean;
    buttonDisabled?: boolean;
    isbackOrdered?: boolean;
    willCall?: boolean;
    isSynchorniCall?: boolean;
}

/**
 * AtpSlotsInformationState: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new AtpSlotsInformationStateInput();
};

/**
 * AtpSlotsInformationState: Use this function to call your action and process the results as needed
 */
async function action(input: AtpSlotsInformationStateInput, ctx: Msdyn365.IActionContext): Promise<IAtpSlotsInformationStateData> {
    return { checkAvailable: false , buttonDisabled: false , isbackOrdered: false , willCall: true , isSynchorniCall: false};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IAtpSlotsInformationStateData>>action,
    // AtpSlotsInformationState: Give your data action a unique id
    id: 'AtpSlotsInformationState',
    input: createInput
    // AtpSlotsInformationState: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
